import { useEffect, useState } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import AccordionVero from "../../../../components/sevices/accordionVero";
import ConfusedMale from "../../../../components/artsPersonComponent/confusedMale";
import TopBarFilter from "../../../../components/topBarFilter";
import DatagridComponent from "../../../../components/datagridComponent";
import GrupoChip from "../../../../components/grupoEconomico/GrupoChip";
import { Box } from "@mui/system";
import useStyles from "./styles";
import {
	Alert,
	Autocomplete,
	Chip,
	Grid,
	LinearProgress,
	Pagination,
	Paper,
	Snackbar,
	TextField,
	Tooltip,
	Typography,
	useTheme,
} from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import dayjs from "dayjs";
import useErpsCliente from "../../../../components/erp/useErpsCliente";

export default function Contratos() {
	// ERP do cliente logado: contratos existem no VERO e no IXC (grupo
	// econômico com HubSoft + IXC: os contratos das empresas IXC).
	const { temTipo, carregado: erpsCarregados } = useErpsCliente();
	const erp = temTipo("VERO") ? "VERO" : temTipo("IXC") ? "IXC" : "";
	const { apiCliente, controllerDashboard, setControllerDashboard } =
		useOutletContext();
	const [clienteInfo, setClienteInfo] = useState({});
	const [contratos, setContratos] = useState([]);
	const [loading, setLoading] = useState(true);
	const [snackbar, setSnackbar] = useState(null);
	const [page, setPage] = useState(1);

	const [openFilter, setOpenFilter] = useState(false);
	const [selectService, setSelectService] = useState(null);
	const [selectStatus, setSelectStatus] = useState(null);
	const [isGrupo, setIsGrupo] = useState(false);

	const windowWith = window.innerWidth;
	const rowsPerPage = 11;
	const labelErp = "Contratos";
	const theme = useTheme();
	const styles = useStyles(theme);

	useEffect(() => {
		// Espera o ERP do cliente (decide a busca).
		if (!erpsCarregados) return undefined;
		const localUser = JSON.parse(localStorage.getItem("userCliente"));
		setClienteInfo(localUser || {});

		const clienteErpId = localUser?.usuarioCliente?.cliente?.clienteErpId;
		const cnpj = localUser?.usuarioCliente?.cliente?.cnpj;

		if (erp === "VERO") {
			// O backend também resolve o cliente pelo x-user-id: não bloqueia o
			// fetch quando cnpj/clienteErpId estiverem vazios (grupo econômico)
			getAllContratos(clienteErpId, cnpj);
		} else if (erp === "IXC") {
			// Grupo econômico (IXC): consolida os contratos dos membros visíveis
			verificarGrupoEconomico();
		} else {
			setLoading(false);
		}

		return () => {
			if (controllerDashboard) {
				controllerDashboard.abort();
			}
		};
	}, [erpsCarregados]); // eslint-disable-line react-hooks/exhaustive-deps

	async function verificarGrupoEconomico() {
		try {
			const response = await apiCliente.post("/cliente/find/empresasGrupo", {});

			if (response?.data?.isGrupo) {
				setIsGrupo(true);
				await getAllContratos(null, null);
			} else {
				setLoading(false);
			}
		} catch (error) {
			console.error(error);
			setLoading(false);
		}
	}

	async function getAllContratos(clienteErpId, cnpj) {
		try {
			const response = await apiCliente.post("/cliente/find/allContratos", {
				cnpj: cnpj,
				clienteErpId: clienteErpId,
			});
			setContratos(response.data || []);
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	}

	const handleCloseSnackbar = () => setSnackbar(null);

	const handleChangePagination = (event, value) => {
		setPage(value);
	};

	const montarEndereco = (contrato) => {
		const {
			ENDER_COB_LOGR_TIPO,
			ENDER_COB_LOGR_NOM,
			ENDER_COB_NUM,
			ENDER_COB_COMPL,
			ENDER_COB_BAIR_NOM,
			ENDER_COB_CDE_NOM,
			ENDER_COB_UF,
			ENDER_COB_CEP,
		} = contrato;

		return `${ENDER_COB_LOGR_TIPO} ${ENDER_COB_LOGR_NOM}, ${ENDER_COB_NUM} ${ENDER_COB_COMPL ? `- ${ENDER_COB_COMPL}` : ""} - ${ENDER_COB_BAIR_NOM}, ${ENDER_COB_CDE_NOM}/${ENDER_COB_UF} - CEP: ${ENDER_COB_CEP}`;
	};

	// Usuário de grupo econômico (IXC): os contratos consolidados chegam com o
	// membro dono (ownerNome) — exibe a coluna "Empresa" somente nesse caso
	const temEmpresaGrupo = contratos?.some((c) => !!c?.ownerNome);

	const allService = contratos?.map((c) =>
		erp === "VERO"
			? {
					id: c?.COD_CNTR,
					nome: c?.PRODUTO_NOME,
				}
			: {
					id: c?.id_cliente_servico,
					nome: c?.servico,
				},
	);

	const statusOptionsUnique = [
		...new Set(
			contratos?.map((c) =>
				erp === "VERO" ? c?.DESCR_STAT_CNTR : c?.statusContrato,
			),
		),
	]?.map((status) => ({ status }));

	const filteredContratos = contratos?.filter((contrato) => {
		const idContrato =
			erp === "VERO" ? contrato?.COD_CNTR : contrato?.id_cliente_servico;
		const statusContrato =
			erp === "VERO" ? contrato?.DESCR_STAT_CNTR : contrato?.statusContrato;

		const matchService = selectService
			? idContrato === selectService?.id
			: true;
		const matchStatus = selectStatus
			? statusContrato === selectStatus?.status
			: true;
		return matchService && matchStatus;
	});

	const totalAccordions = filteredContratos?.length;
	const totalPages = Math?.ceil(totalAccordions / rowsPerPage);
	const paginatedServices = filteredContratos?.slice(
		(page - 1) * rowsPerPage,
		page * rowsPerPage,
	);

	const chipStatusContrato = (status) => {
		switch (status) {
			case "Em vigência":
				return (
					<Tooltip title={"Em vigência"}>
						<Chip sx={styles.chipVigencia} label={"Em vigência"} />
					</Tooltip>
				);
			case "Próximo de expirar":
				return (
					<Tooltip title={"Próximo de expirar"}>
						<Chip sx={styles.chipProxima} label={"Próximo de expirar"} />
					</Tooltip>
				);
			case "Expirado":
				return (
					<Tooltip title={"Expirado"}>
						<Chip sx={styles.chipExpirado} label={"Expirado"} />
					</Tooltip>
				);
			default:
				return status || "";
		}
	};

	// Tabela usada apenas para usuário de grupo econômico (IXC)
	const columnsIxcGrupo = [
		{
			field: "id_cliente_servico",
			headerName: "ID Contrato",
			flex: 0.6,
		},
		...(temEmpresaGrupo
			? [
					{
						field: "ownerNome",
						headerName: "Empresa",
						flex: 1.2,
						renderCell: (params) =>
							params?.row?.ownerNome ? (
								<GrupoChip variant="owner" label={params?.row?.ownerNome} />
							) : (
								""
							),
					},
				]
			: []),
		{
			field: "servico",
			headerName: "Serviço",
			flex: 1.5,
			renderCell: (params) => (
				<Tooltip title={params?.value || ""} arrow placement="top-start">
					<span
						style={{
							whiteSpace: "nowrap",
							overflow: "hidden",
							textOverflow: "ellipsis",
							width: "100%",
							display: "block",
						}}
					>
						{params?.value}
					</span>
				</Tooltip>
			),
		},
		{
			field: "validade",
			headerName: "Validade",
			flex: 0.7,
			renderCell: (params) =>
				params?.value
					? `${params?.value} ${params?.value > 1 ? "meses" : "mês"}`
					: "",
		},
		{
			field: "data_inicio_contrato",
			headerName: "Início Contrato",
			flex: 0.8,
			renderCell: (params) =>
				params?.value ? dayjs(params?.value).format("DD/MM/YYYY") : "",
		},
		{
			field: "statusContrato",
			headerName: "Status contrato",
			flex: 0.9,
			renderCell: (params) => chipStatusContrato(params?.value),
		},
		{
			field: "dataExpiracao",
			headerName: "Expira em",
			flex: 0.8,
			renderCell: (params) =>
				params?.value ? dayjs(params?.value).format("DD/MM/YYYY") : "",
		},
		{
			field: "status_servico",
			headerName: "Status serviço",
			flex: 0.8,
		},
		{
			field: "valor",
			headerName: "Valor (R$)",
			flex: 0.7,
			renderCell: (params) => {
				const valor = Number(params?.value);
				return Number.isFinite(valor)
					? valor.toLocaleString("pt-BR", {
							style: "currency",
							currency: "BRL",
						})
					: "";
			},
		},
	];

	const actions = [
		{
			icon: <FilterAltOutlinedIcon />,
			name: "Filtro",
			onClick: () => setOpenFilter(true),
		},
	];

	const selectorComponentLeft = (
		<Box sx={styles.boxFilters}>
			<Autocomplete
				size="small"
				value={selectService}
				options={allService || []}
				sx={styles.searchField}
				getOptionLabel={(option) => {
					if (!option || (!option?.id && !option?.nome)) return "";
					return `${option?.id ?? ""} - ${option?.nome ?? ""}`;
				}}
				onChange={(event, newValue) => {
					setSelectService(newValue);
					setPage(1);
				}}
				renderInput={(params) => (
					<TextField {...params} label={`${labelErp}`} />
				)}
			/>
			<Autocomplete
				size="small"
				value={selectStatus}
				options={statusOptionsUnique || []}
				getOptionLabel={(option) => {
					if (!option || !option?.status) return "";
					return option?.status;
				}}
				isOptionEqualToValue={(option, value) =>
					option?.status === value?.status
				}
				sx={styles.searchField}
				onChange={(event, newValue) => {
					setSelectStatus(newValue);
					setPage(1);
				}}
				renderInput={(params) => <TextField {...params} label="Status" />}
			/>
		</Box>
	);

	return (
		<Box sx={styles.pageBox}>
			<TopBarFilter
				actions={actions}
				selectorComponentLeft={selectorComponentLeft}
				selectorComponentRight={<Box></Box>}
				windowWidth={windowWith}
				openFilter={openFilter}
				setOpenFilter={setOpenFilter}
			/>
			<Paper sx={styles.paper}>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						mb: 2,
					}}
				>
					<Typography variant="mySubtitle">Contratos</Typography>
				</Box>

				<Grid item xs={12} sx={{ mt: 2 }}>
					{loading && <LinearProgress />}
					{totalAccordions === 0 || paginatedServices?.length === 0 ? (
						<Box sx={styles.containerNoTickets}>
							{!loading && (
								<Box
									sx={styles.paperNoTickets}
									elevation={theme.palette.mode === "dark" ? 0 : 3}
								>
									<Box sx={styles.containerImgNoTickets}>
										<ConfusedMale
											mainFill={theme.palette.secondary.dark}
											primaryCircleFill={theme.palette.secondary.main}
											highlightTitle={"Oops!"}
											subtitle={`Parece que não\nencontramos nenhum\n${labelErp.toLocaleLowerCase()}.`}
										/>
									</Box>
								</Box>
							)}
						</Box>
					) : erp === "VERO" ? (
						paginatedServices?.map((contrato) => (
							<AccordionVero
								key={contrato?.COD_CNTR}
								id={contrato?.COD_CNTR}
								nome={contrato?.PRODUTO_NOME}
								status={contrato?.DESCR_STAT_CNTR}
								setSnackbar={setSnackbar}
								dataCadastroContrato={dayjs(contrato?.DAT_CNTR)?.format(
									"DD/MM/YYYY HH:mm",
								)}
								dataFimContrato={dayjs(contrato?.DAT_CANCL)?.format(
									"DD/MM/YYYY HH:mm",
								)}
								dataInicioContrato={dayjs(contrato?.DAT_ATIV_CNTR)?.format(
									"DD/MM/YYYY HH:mm",
								)}
								formaPagamento={contrato?.FORM_PAGTO}
								diaVencimento={contrato?.DIA_VENC}
								categoria={contrato?.CATEGORIA_PRODUTO}
								permiteAlterarWifi={
									contrato?.FLAG_PERMITE_ALTERACAO_WIFI === "SIM"
								}
								enderecoCompleto={montarEndereco(contrato)}
								valor={contrato?.VLR_CNTR}
								ownerNome={contrato?.ownerNome}
							/>
						))
					) : erp === "IXC" && isGrupo ? (
						<Box sx={{ height: "500px" }}>
							<DatagridComponent
								loading={loading}
								rows={filteredContratos || []}
								columns={columnsIxcGrupo}
							/>
						</Box>
					) : null}

					{erp === "VERO" && totalPages > 1 && totalAccordions > 0 && (
						<Box sx={styles.pagination}>
							<Pagination
								count={totalPages}
								page={page}
								onChange={handleChangePagination}
							/>
						</Box>
					)}
				</Grid>

				{!!snackbar && (
					<Snackbar
						open
						anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
						onClose={handleCloseSnackbar}
						autoHideDuration={3000}
					>
						<Alert {...snackbar} onClose={handleCloseSnackbar} />
					</Snackbar>
				)}
			</Paper>
		</Box>
	);
}
